var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',[_c('v-spacer'),_c('div',[_vm._v("© "+_vm._s(new Date().getFullYear()))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }